import DeleteBranchModal from './delete-branch-modal';

export default DeleteBranchModal;
